module.exports = __webpack_public_path__ + "img/nav-design-diamonds@2x.496479d.jpg";